import { createSlice } from "@reduxjs/toolkit";

interface ThemeState extends Object {
  collapsedSidebar: boolean;
}

const initialState: ThemeState = {
  collapsedSidebar: false,
};

const themeSlice = createSlice({
  name: "theme",
  initialState: initialState,
  reducers: {
    toggleCollapsedSidebar: (state) => {
      return {
        ...state,
        collapsedSidebar: !state.collapsedSidebar,
      };
    },
  },
});

export const { toggleCollapsedSidebar } = themeSlice.actions;

export default themeSlice.reducer;
